import React from "react";
import "./Loading.css"


const LoadingImg = () => {
    return (
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 444.2 588.34">
  <g>
    <path class="cls-1" d="M1004.19,413.46a242.65,242.65,0,0,0-39.49-5.55c-.41,0-.83,0-1.24,0v393.3a10.29,10.29,0,0,0,1.24,0c115.69-6.79,207.21-92.18,207.21-196.6C1171.91,512.34,1100.57,435,1004.19,413.46Zm0,315.06v-248c57.27,0,103.74,55.52,103.74,124S1061.46,728.52,1004.19,728.52Zm-276.48-124c0,104.07,90.83,189.18,206,196.51V408a244.93,244.93,0,0,0-37,5.14C799.69,434.24,727.71,511.89,727.71,604.52Zm169,123.56C839.4,728.08,793,672.56,793,604S839.4,480,896.72,480Z" transform="translate(-727.71 -212.83)"/>
    <path class="cls-2" d="M896.72,480a88.14,88.14,0,0,1,37,8.13V719.94a88,88,0,0,1-37,8.14Z" transform="translate(-727.71 -212.83)"/>
    <path class="cls-2" d="M1000.46,604c0,37.41-13.83,70.94-35.76,93.65-.41.4-.78.85-1.24,1.25V509.12c.41.4.83.81,1.24,1.25C986.63,533.13,1000.46,566.65,1000.46,604Z" transform="translate(-727.71 -212.83)"/>
    <path class="cls-2" d="M900.4,604.52c0-35.94,12.78-68.31,33.28-90.93v181.9C913.18,672.87,900.4,640.46,900.4,604.52Z" transform="translate(-727.71 -212.83)"/>
    <path class="cls-2" d="M1004.19,480.51v248a89,89,0,0,1-39.49-9.29c-.41-.23-.83-.41-1.24-.63V490.48c.41-.27.83-.45,1.24-.67A89,89,0,0,1,1004.19,480.51Z" transform="translate(-727.71 -212.83)"/>
    <polygon class="cls-1" points="162.46 0 205.97 59.45 205.97 569.65 162.35 569.65 162.35 0 162.46 0"/>
    <polygon class="cls-1" points="278.92 0.53 278.92 570.18 235.75 570.18 234.11 59.35 278.76 0.53 278.92 0.53"/>
  </g>
</svg>
    );
}

export default LoadingImg;
